import { TextInput } from '@mantine/core';
import { IFormInputSpecTextExpression } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a text expression input. Shown in the template configurator.
 */
export default function TextExpressionInputPreview({ spec }: { spec: IFormInputSpecTextExpression }) {
  return <TextInput required={spec.required} readOnly size="sm" placeholder={spec.template || '…'} />;
}
